import request from 'common/utils/requests'

// //  Choice事件接口
export const choiceAction = (data: any) =>
  request.post(`/merchant/checkout/counter/handle/action`, data)
